export const userInitials = (name) => {
  const singleInitials = name.charAt(0).toUpperCase();

  if (name.split(" ").length > 1) {
    const doubleName = name.split(' ');
    const doubleInitials = doubleName.shift().charAt(0) + doubleName.pop().charAt(0);
    return doubleInitials.toUpperCase();
  }

  return singleInitials;
};
